import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { productosSearch } from '../../models/productosSearch'
import { Observable } from 'rxjs/Observable';
// import { delay } from 'rxjs/operators';
import { Storage } from '@ionic/storage'
import { URL_SERVICIOS_LOCALES, NUBE_AWS, URL_SERVICIOS_AWS } from '../../config/url.servicio'

@Injectable()
export class ProductosPorGruposProvider {
  token:string
  constructor(public http: Http, private storage:Storage) {
    this.storage.get('token').then((val) => {
      this.token = val
  });
  }

  buscar() {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=productosPorGrupos`)
      .map((data) => data.json())
  }
  buscarProductoCompania(companias:any) {
    if(NUBE_AWS) {
      let valor = parseInt(companias)
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarProductoCompania",
        parameters : {companiasId:valor}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES

      let valor = parseInt(companias)
      return this.http.get(`${url}/proceso/buscarProductoCompania?companiasId=${valor}`)
      .map((data) => data.json())
   }
  }

  buscarProductoElaboradosCompania(companias:any) {
    if(NUBE_AWS) {
      let valor = parseInt(companias)
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarProductoElaboradosCompania",
        parameters : {companiasId:valor}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES

      let valor = parseInt(companias)
      return this.http.get(`${url}/proceso/buscarProductoElaboradosCompania?companiasId=${valor}`)
      .map((data) => data.json())
   }
  }

  busca(data:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarProductosPorGrupos",
        parameters : {companiasId:data.companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES

      return this.http.get(`${url}/query?name=buscarProductosPorGrupos&companiasId=${data.companiasId}`)
      .map((data) => data.json())
   }
  }

  buscarporCompania(data:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarProductosPorGrupos",
        parameters : {companiasId:data}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES

      return this.http.get(`${url}/query?name=buscarProductosPorGrupos&companiasId=${data}`)
      .map((data) => data.json())
   }
  }

  buscarProductosPorGruposDrag(companiasId:any,gruposProductosId:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarProductosPorGruposDrag",
        parameters : {companiasId:companiasId,
                      gruposProductosId:gruposProductosId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES

      return this.http.get(`${url}/query?name=buscarProductosPorGruposDrag&companiasId=${companiasId}&gruposProductosId=${gruposProductosId}`)
      .map((data) => data.json())
   }
  }

  buscarGruposReservasProductosPorGruposDrag(companiasId:any,gruposProductosId:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarGruposReservasProductosPorGruposDrag",
        parameters : {companiasId:companiasId,
                      gruposProductosId:gruposProductosId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES

      return this.http.get(`${url}/query?name=buscarProductosPorGruposDrag&companiasId=${companiasId}&gruposProductosId=${gruposProductosId}`)
      .map((data) => data.json())
   }
  }

  buscarTiposReservasProductosPorGruposDrag(companiasId:any,tiposReservasId:any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarTiposReservasProductosPorGruposDrag",
        parameters : {companiasId:companiasId,
          tiposReservasId:tiposReservasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
  }

  buscarProveedoraProductosEquivalenciaDrag(companiasId:any,proveedoraPorProductoId:any,productosElaboradosId:any,productosId:any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "buscarProveedoraProductosEquivalenciaDrag",
      parameters : {companiasId:companiasId,
        proveedoraPorProductoId:proveedoraPorProductoId,
        productosElaboradosId:productosElaboradosId,
        productosId:productosId
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);
}

buscarProveedoraProductosEquivalenciaPorProveedoraPorProductoIdDrag(companiasId:any,proveedoraPorProductoId:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "buscarProveedoraProductosEquivalenciaPorProveedoraPorProductoIdDrag",
    parameters : {companiasId:companiasId,
      proveedoraPorProductoId:proveedoraPorProductoId
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}
  // afn modificar
  buscarProductos() {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=productos`)
    .map((data) => {
      let productossearch: productosSearch[]
      let page: number = 1, size: number = 4000
      productossearch = data.json()
      return productossearch.slice((page - 1) * size, ((page - 1) * size) + size);
    })
  }

  buscarGrupos() {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=gruposProductos`)
      .map((data) => data.json())
  }

  buscarGruposCompaniasId(valor) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscargruposProductos",
        parameters : {companiasId:valor}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscargruposProductos&companiasId=${valor}`)
        .map((data) => data.json())
   }
  }

  buscargruposReservasCompaniasId(valor) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscargruposReservas",
        parameters : {companiasId:valor}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
  }

  guardar(productosPorGrupos: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: productosPorGrupos.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "I",
          productosPorGruposId : productosPorGrupos.productosPorGruposId,
          nombreTabla: "productosPorGrupos",
          ...productosPorGrupos
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options).map((data) => {
        data.json()},
        err => {
        }
      );
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.post(`${url}/query`, productosPorGrupos, options)
        .map((data) => {
          data.json()},
          err => {
          }
        )
   }
  }


  almacenarVariosRegistros(productosPorGrupos: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: 'almacenarVariosRegistros',
        parameters : {
          name:'productosPorGrupos',
          json: JSON.stringify([productosPorGrupos])
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options).map((data) => {
        data.json()},
        err => {
        }
      );
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.post(`${url}/query`, productosPorGrupos, options)
        .map((data) => {
          data.json()},
          err => {
          }
        )
   }
  }


  almacenarVariosRegistrosGruposReservasPorProductos(productosPorGrupos: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data
      if(productosPorGrupos.tipo !== "M") {
        data = {
          name: 'dataDynamicCrud',
          parameters : {
            queHago: "I",
            name:'dataDynamicCrud',
            nombreTabla: 'gruposReservasPorProducto',
            ...productosPorGrupos
          }
        }
      } else {
        data = {
          name: 'guardarGruposReservasPorProductoElaborado',
          parameters : {
            gruposReservasId: productosPorGrupos.gruposReservasId,
            mesasId: productosPorGrupos.mesasId
          }
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options).map((data) => {
        data.json()},
        err => {
        }
      );
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.post(`${url}/query`, productosPorGrupos, options)
        .map((data) => {
          data.json()},
          err => {
          }
        )
   }
  }


  almacenarClientesBulkInsert(clientes: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: 'almacenarClientesBulkInsert',
        parameters : {
          json: JSON.stringify([clientes])
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options).map((data) => {
        data.json()},
        err => {
        }
      );
    }
  }



  actualizar(productosPorGrupos: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: productosPorGrupos.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "A",
          productosPorGruposId : productosPorGrupos.productosPorGruposId,
          nombreTabla: "productosPorGrupos",
          ...productosPorGrupos
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.put(`${url}/query`, productosPorGrupos, options)
   }
  }


  actualizarTodoafn(data: any) {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })
    return this.http.put(`${url}/query`, data, options)
  }

  actualizarTodoafnafn (productosId:any,ubicacionId:any,contenedorId:any){
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "productosId": JSON.stringify(productosId),
        "ubicacionId": JSON.stringify(ubicacionId),
        "contenedorId":JSON.stringify(contenedorId)
        }

    return this.http
          .post(`${url}/proceso/actualizarUbicacionPorProducto`, datos, options)
}

  actualizarTodo (productosId:any,ubicacionId:any,contenedorId:any){
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "productosId": JSON.stringify(productosId),
        "ubicacionId": JSON.stringify(ubicacionId),
        "contenedorId":JSON.stringify(contenedorId)
        }

    return this.http
          .post(`${url}/proceso/actualizarUbicacionPorProducto`, datos, options)
        // .post(`${url}/proceso/actualizarUbicacionPorProducto`, datos, options)
        // .map((valores)=>{
        //   valores.json()
        // },(error)=>{
        //   console.log(error)
        // })
}



guardarProductosElaboradosDinamicos (jsonProductosElaboradosDinamicos:any,jsonProductosElaboradosDinamicosPorProductos:any,cantidad:any){
  let url = URL_SERVICIOS_LOCALES
  let headers = new Headers({
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + this.token
  })

  let options = new RequestOptions({
      headers: headers
  })

  const datos = {
      "jsonProductosElaboradosDinamicos": JSON.stringify(jsonProductosElaboradosDinamicos),
      "jsonProductosElaboradosDinamicosPorProductos": JSON.stringify(jsonProductosElaboradosDinamicosPorProductos),
      "cantidad": cantidad
    }

  return this.http
        .post(`${url}/proceso/guardarProductosElaboradosDinamicos`, datos, options)
  }

  eliminar(productosPorGrupos: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: productosPorGrupos.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          productosPorGruposId : productosPorGrupos.productosPorGruposId,
          nombreTabla: "productosPorGrupos",
          ...productosPorGrupos
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&productosPorGruposId=${productosPorGrupos.productosPorGruposId}&nombreTabla=productosPorGrupos`, options)
   }
  }

  buscarTodosLosProductosPorCompanias(valor) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name : "buscarTodosLosProductosPorCompanias",
        parameters : {
          companiasId: valor
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarTodosLosProductosPorCompanias&companiasId=${valor}`)
        .map((data) => data.json())
   }
  }

  buscarTodosLosProductosPorReservasCompanias(valor) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name : "buscarTodosLosProductosPorReservasCompanias",
        parameters : {
          companiasId: valor
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }


  buscarTodosLosProductosPorCompaniasDragAndDrop(valor) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarTodosLosProductosPorCompaniasDragAndDrop",
        parameters : {
          name : "buscarTodosLosProductosPorCompaniasDragAndDrop",
          companiasId: valor
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarTodosLosProductosPorCompaniasDragAndDrop&companiasId=${valor}`)
        .map((data) => data.json())
   }
  }

  buscarProductosElaboradosDinamicos(companiasId:any,productosElaboradosId:any,usuariosId:any,numeroMesa:any,cantidad:any,productosElaboradosDinamicosId:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarProductosElaboradosDinamicos",
        parameters : {
          name : "buscarProductosElaboradosDinamicos",
          companiasId: companiasId,
          productosElaboradosId:productosElaboradosDinamicosId,
          usuariosId:usuariosId,
          numeroMesa:numeroMesa,
          cantidad:cantidad,
          productosElaboradosDinamicosId:productosElaboradosDinamicosId
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarProductosElaboradosDinamicos&companiasId=${companiasId}&productosElaboradosId=${productosElaboradosId}&usuariosId=${usuariosId}&numeroMesa=${numeroMesa}&cantidad=${cantidad}&productosElaboradosDinamicosId=${productosElaboradosDinamicosId}`)
        .map((data) => data.json())
   }
  }

  eliminarGrupoReservasPorCompanias(item: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: item.name == undefined ? item.nombreTabla : item.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          gruposReservasPorProductoId : item.gruposReservasPorProductoId == undefined ? item.productosPorGruposId : item.gruposReservasPorProductoId,
          nombreTabla: "gruposReservasPorProducto",
          ...item
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&productosPorGruposId=${item.productosPorGruposId}&nombreTabla=productosPorGrupos`, options)
   }
  }

  eliminarProductosPorGrupoPorCompanias(item: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: item.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          productosPorGruposId : item.productosPorGruposId,
          nombreTabla: "productosPorGrupos",
          ...item
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&productosPorGruposId=${item.productosPorGruposId}&nombreTabla=productosPorGrupos`, options)
   }
  }
  buscarTiposReservasPorValorCompaniasId(valor) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "buscarTiposReservasPorValorCompaniasId",
      parameters : {companiasId:valor}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);
}
buscarTiposReservasControlaPrecio(valor) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "buscarTiposReservasControlaPrecio",
      parameters : {companiasId:valor}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);
}

buscarEstadosParqueaderosPorValorControlaPrecio(valor) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "buscarEstadosParqueaderosPorValorControlaPrecio",
    parameters : {companiasId:valor}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}


buscarProveedoraProductosEquivalencia(valor) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "buscarProveedoraProductosEquivalencia",
    parameters : {companiasId:valor}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}

buscarProductosTraslados(valor) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "buscarProductosTraslados",
    parameters : {companiasId:valor}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}



buscarProveedoraPorProductosIdEquivalencia(valor:any,productosElaboradosId: any ) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "buscarProveedoraPorProductosIdEquivalencia",
    parameters : {companiasId:valor, productosElaboradosId: productosElaboradosId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}

actualizarTiposReservasPorValor(companiasId: any,tiposReservasPorValorId: any,valor: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "actualizarTiposReservasPorValor",
    parameters : {companiasId:companiasId,
      tiposReservasPorValorId:tiposReservasPorValorId,
      valor:valor
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);

}

buscarTiposReservasNoControlaPrecio(valor) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "buscarTiposReservasNoControlaPrecio",
    parameters : {companiasId:valor}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}


buscarReservasSinAsignarDrag(companiasId:any,tiposReservasId:any) {

    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "buscarReservasSinAsignarDrag",
      parameters : {companiasId:companiasId,
        tiposReservasId:tiposReservasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);
}

almacenarVariosRegistrosReservasSinAsignar(companiasId: any,gruposReservasPorProductoId: any,tiposReservasId: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "guardarReservasSinAsignarDrag",
    parameters : {companiasId:companiasId,
      gruposReservasPorProductoId:gruposReservasPorProductoId,
      tiposReservasId:tiposReservasId
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}

guardarProveedoraPorProducto(productosElaboradosId: any,proveedoraPorProductoId: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "guardarProveedoraPorProducto",
    parameters : {
      productosElaboradosId:productosElaboradosId,
      proveedoraPorProductoId:proveedoraPorProductoId
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}

buscarTodosLosProductosPorReservasSinAsignar(valor) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name : "buscarTodosLosProductosPorReservas",
    parameters : {
      companiasId: valor
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}
buscarProveedoraProductosElaborados(valor) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name : "buscarProveedoraProductosElaborados",
    parameters : {
      companiasId: valor
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}


actualizarTiposReservasControlaPrecioSi(gruposReservasPorProductoId: any,
	tiposReservasIdControlaPrecioSi: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "actualizarTiposReservasControlaPrecioSi",
    parameters : {gruposReservasPorProductoId:gruposReservasPorProductoId,
      tiposReservasIdControlaPrecioSi:tiposReservasIdControlaPrecioSi
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}

actualizarTiposReservasControlaPrecioNo(gruposReservasPorProductoId: any,
	tiposReservasIdControlaPrecioNo: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "actualizarTiposReservasControlaPrecioNo",
    parameters : {gruposReservasPorProductoId:gruposReservasPorProductoId,
      tiposReservasIdControlaPrecioNo:tiposReservasIdControlaPrecioNo
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}


eliminarReservasSinasignar(item: any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: item.name,
      parameters : {
        name : "dataDynamicCrud",
        queHago: "E",
        tiposReservasSinAsignarId : item.tiposReservasSinAsignarId,
        nombreTabla: "tiposReservasSinAsignar",
        ...item
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  eliminarproveedoraPorProducto(item: any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: item.name,
      parameters : {
        name : "dataDynamicCrud",
        queHago: "E",
        proveedoraPorProductoId : item.proveedoraPorProductoId,
        nombreTabla: "proveedoraPorProducto",
        ...item
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  actualizarlistaproveedoraPorProductoEquivalencia(valores: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {}
      if(valores.proveedoraPorProductoEquivalenciaId == 0){
        data = {
          name: "proveedoraPorProductoEquivalencia",
          parameters : {
            name : "dataDynamicCrud",
            queHago: "I",
            proveedoraPorProductoId : valores.proveedoraPorProductoId,
            nombreTabla: "proveedoraPorProductoEquivalencia",
            productosId: valores.productosElaboradosId,
            equivalencia: valores.equivalencia
          }
      }
    } else {
        data = {
          name: "proveedoraPorProductoEquivalencia",
          parameters : {
            name : "dataDynamicCrud",
            queHago: "A",
            proveedoraPorProductoEquivalenciaId : valores.proveedoraPorProductoEquivalenciaId,
            proveedoraPorProductoId : valores.proveedoraPorProductoId,
            nombreTabla: "proveedoraPorProductoEquivalencia",
            productosId: valores.productosElaboradosId,
            equivalencia: valores.equivalencia
          }
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    }
  }

  actualizarCantidadProducto(item: any, i:any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "actualizarTiposReservasControlaPrecioSi",
      parameters : {gruposReservasPorProductoId:item,
        tiposReservasIdControlaPrecioSi:i
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);

  }


  transferirCantidadPorProducto(companiasId: any, productosId: any,valorTransferir: any,equivalencia: any,productosElaboradosIdProveedor:any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "transferirCantidadPorProducto",
      parameters : {
        companiasId:companiasId,
        productosId:productosId,
        valorTransferir: valorTransferir,
        equivalencia: equivalencia,
        productosElaboradosId:productosElaboradosIdProveedor
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);

  }

  actualizarEstadosParqueaderosPorValor(companiasId: any,estadosParqueaderosPorValorId: any,valor: any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "actualizarEstadosParqueaderosPorValor",
      parameters : {companiasId:companiasId,
        estadosParqueaderosPorValorId:estadosParqueaderosPorValorId,
        valor:valor
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);

  }

  buscarParqueaderoPorProductoPorGruposDrag(companiasId:any,estadosParqueaderosId:any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "buscarParqueaderoPorProductoPorGruposDrag",
      parameters : {companiasId:companiasId,
        estadosParqueaderosId:estadosParqueaderosId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);
}
buscarSeguimientosReservasGrupales(valor) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "buscarSeguimientosReservasGrupales",
    parameters : {companiasId:valor}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}

buscarReservasEstados(valor) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "buscarReservasEstados",
    parameters : {companiasId:valor}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}

buscarSeguimientosReservasGrupalesDrag(companiasId:any,seguimientosReservasId:any, clientesId:any =0) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "buscarSeguimientosReservasGrupalesDrag",
      parameters : {companiasId:companiasId,
        seguimientosReservasId:seguimientosReservasId,
        clientesId:clientesId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);

}

actualizarReservasGrupales(seguimientosReservasId:any,clientesId:any,reservasEstadosViajesId:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "actualizarReservasGrupales",
    parameters : {seguimientosReservasId:seguimientosReservasId,
      clientesId:clientesId,
      reservasEstadosViajesId:reservasEstadosViajesId
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}

actualizarReservasPorReservasIdGrupales(seguimientosReservasId:any,clientesId:any,reservasEstadosReservasId:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "actualizarReservasPorReservasGrupales",
    parameters : {seguimientosReservasId:seguimientosReservasId,
      clientesId:clientesId,
      reservasEstadosReservasId:reservasEstadosReservasId
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);
}

guardarReservasGrupalesPorClientes(reservasGrupalesId:any,clientesId:any = 0,
  tiposReservasIdControlaPrecioSi:any,
  reservasPuntosDeEncuentrosId:any,
  reservasEstadosViajesId:any,
  reservasEstadosReservasId:any,
  cuentasPorCobrarId:any,
  seguimientosReservasId:any,
  usuariosId:any
) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "guardarReservasGrupalesPorClientes",
    parameters : {reservasGrupalesId:reservasGrupalesId,
      clientesId:clientesId,
      tiposReservasIdControlaPrecioSi:tiposReservasIdControlaPrecioSi,
      reservasPuntosDeEncuentrosId:reservasPuntosDeEncuentrosId,
      reservasEstadosViajesId:reservasEstadosViajesId,
      reservasEstadosReservasId:reservasEstadosReservasId,
      cuentasPorCobrarId:cuentasPorCobrarId,
      seguimientosReservasId:seguimientosReservasId,
      usuariosId:usuariosId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);

}


buscarSeguimientosReservasGrupalesPorReserva(companiasId:any,seguimientosReservasId:any,reservasGrupalesId:any
) {
  let url_servicio = URL_SERVICIOS_AWS;
  let request = {
    name: "buscarSeguimientosReservasGrupalesPorReserva",
    parameters : {companiasId:companiasId,
      seguimientosReservasId:seguimientosReservasId,
      reservasGrupalesId:reservasGrupalesId
      }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, request, options);

}

eliminarEeservasGrupalesPorCompanias(item: any) {
 let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: item.name == undefined ? item.nombreTabla : item.name,
      parameters : {
        name : "dataDynamicCrud",
        queHago: "E",
        reservasGrupalesId : item.reservasGrupalesId == undefined ? item.reservasGrupalesId : item.reservasGrupalesId,
        nombreTabla: "reservasGrupales",
        ...item
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);

}

eliminarRegistroReservasGrupalesPorCliente(item: any) {
  let url_servicio = URL_SERVICIOS_AWS;
     let data = {
       name: item.name == undefined ? item.nombreTabla : item.name,
       parameters : {
         name : "dataDynamicCrud",
         queHago: "E",
         reservasGrupalesPorClientesId : item.reservasGrupalesPorClientesId == undefined ? item.reservasGrupalesPorClientesId : item.reservasGrupalesPorClientesId,
         nombreTabla: "reservasGrupalesPorClientes",
         ...item
       }
     }
     let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
     let options = new RequestOptions({ headers: headers }) // Create a request option
     return this.http.post(`${url_servicio}/procedure`, data, options);

 }

 buscarProductostraslados(companiasId: any,productosId:any,tipo:any) {
  let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: 'buscarProductostraslados',
      parameters : {
        companiasId:companiasId,
        productosId:productosId,
        tipo:tipo
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options).map((data) => {
      data.json()},
      err => {
      }
    );
}

}



// WEBPACK FOOTER //
// ./src/providers/productos-por-grupos/productos-por-grupos.ts